<template>
  <div class="" style=" ">
    <template v-if="actualParamsObj.className=='chart-sponsor'">
      <div class style="width:220px;box-shadow: 0 0 2px 1px #e1e1e1;border-radius: 4px;margin:auto;">
        <v-card
          hover
          :elevation="0"
          style="padding:0;border-radius: 4px;"
          @click="showDrawer('chart-sponsor')"
        >
          <div class="box-header box-header-launch">{{ actualParamsObj.name }}</div>
          <div class="box-body">
            <div class=" flex-justify-between flex-y-center" style="">
              <span class=" font-overflow">{{ actualParamsObj.title }}</span>
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-card>
      </div>
      <div class="flex-center connectLine" style="width:220px;height:100px;margin:auto;">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              fab
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="addList('chart-examine','sponsor_-1')">
              <v-list-item-icon>
                <v-icon color="orange">mdi-account-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>审批人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-cc','sponsor_-1')">
              <v-list-item-icon>
                <v-icon color="blue">mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>抄送人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-condition','sponsor_-1')">
              <v-list-item-icon>
                <v-icon color="purple">mdi-source-branch</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>条件分支</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
    <template v-if="actualParamsObj.className=='chart-examine'">
      <div class style="width:220px;box-shadow: 0 0 2px 1px #e1e1e1;border-radius: 4px;margin:auto;">
        <v-card
          hover
          :elevation="0"
          style="padding:0;border-radius: 4px;"
          @click="showDrawer('chart-examine', actualParamsObj.id)"
        >
          <div class="box-header box-header-approval flex-justify-between">
            <span>{{ actualParamsObj.name||'审批' }}</span>
            <span><v-icon @click.stop="delList('chart-examine',actualParamsIndex,fenzhiIndex,actualParamsObj.id)">mdi-close</v-icon></span>
          </div>
          <div class="box-body">
            <div class=" flex-justify-between flex-y-center" style="">
              <span class=" font-overflow">{{ actualParamsObj.title }}</span>
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-card>
      </div>
      <div class="flex-center connectLine" style="width:220px;height:100px;;margin:auto;">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              fab
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="addList('chart-examine', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="orange">mdi-account-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>审批人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-cc', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>抄送人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-condition', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="purple">mdi-source-branch</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>条件分支</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
    <template v-if="actualParamsObj.className=='chart-cc'">
      <div class style="width:220px;box-shadow: 0 0 2px 1px #e1e1e1;border-radius: 4px;;margin:auto;">
        <v-card
          hover
          :elevation="0"
          style="padding:0;border-radius: 4px;"
          @click="showDrawer('chart-cc', actualParamsObj.id)"
        >
          <div class="box-header box-header-cc flex-justify-between">
            <span>{{ actualParamsObj.name||'抄送' }}</span>
            <span><v-icon @click.stop="delList('chart-cc',actualParamsIndex,fenzhiIndex,actualParamsObj.id)">mdi-close</v-icon></span>
          </div>
          <div class="box-body">
            <div class=" flex-justify-between flex-y-center" style="">
              <span class=" font-overflow">{{ actualParamsObj.title }}</span>
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-card>
      </div>
      <div class="flex-center connectLine" style="width:220px;height:100px;;margin:auto;">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              fab
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="addList('chart-examine', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="orange">mdi-account-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>审批人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-cc', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>抄送人</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="addList('chart-condition', actualParamsObj.id)">
              <v-list-item-icon>
                <v-icon color="purple">mdi-source-branch</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>条件分支</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
    <!-- 条件分支容器 - 完全照搬参考项目 -->
    <template v-if="!actualParamsObj.className && actualParamsObj.children&&actualParamsObj.children.length>0">
      <div class="col-main" :class="(actualParamsObj.children&&actualParamsObj.children.length>1)?'col-box-main':''" style="">
        <div v-for="(item,index) in actualParamsObj.children" :key="index" class="col-box" :class="(actualParamsObj.children&&actualParamsObj.children.length>1)?'col-box-more':''">
          <div class="center-line" />
          <div class style="padding:30px 50px 0;position: relative;">
            <div style="width:220px;">
              <div
                class
                style="box-shadow: 0 0 2px 1px #e1e1e1;border-radius: 4px; background:#fff;"
              >
                <v-card
                  hover
                  :elevation="0"
                  style="padding:0;border-radius: 4px;"
                  @click="showDrawer('chart-condition',item.id)"
                >
                  <div class="box-header flex-justify-between flex-y-center">
                    <span style="color:#3296fa;">{{ item.name||'条件' }}</span>
                    <span style="color:#666;"><v-icon @click.stop="delList('chart-condition',index,fenzhiIndex,item.id)">mdi-close</v-icon></span>
                  </div>
                  <div class="box-body font-overflow">
                    {{ item.title }}
                  </div>
                </v-card>
              </div>
              <div class="flex-center connectLine" style="height:100px;">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      fab
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="addList('chart-examine',item.id)">
                      <v-list-item-icon>
                        <v-icon color="orange">mdi-account-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>审批人</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="addList('chart-cc',item.id)">
                      <v-list-item-icon>
                        <v-icon color="blue">mdi-account-multiple</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>抄送人</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="addList('chart-condition',item.id)">
                      <v-list-item-icon>
                        <v-icon color="purple">mdi-source-branch</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>条件分支</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </div>
          </div>
          <condition
            v-for="(_item,_index) in item.children"
            :key="_index"
            :params-obj="_item"
            :params-index="_index"
            :fenzhi-index="index"
            @addList="addListC"
            @delList="delListC"
            @showDrawer="onShowDrawer"
          />
        </div>
      </div>
      <div v-if="(actualParamsObj.children&&actualParamsObj.children.length>1)" class="flex-center connectLine" style="height:100px;" />
    </template>

    <!-- &&actualParamsObj.children[0].className!='condition' -->
    <template v-if="actualParamsObj.className=='chart-sponsor'||actualParamsObj.className=='chart-examine'||actualParamsObj.className=='chart-cc'">
      <template v-if="actualParamsObj.children&&actualParamsObj.children.length">
        <condition
          v-for="(item,index) in actualParamsObj.children"
          :key="index"
          :params-obj="item"
          :params-index="index"
          @addList="addListC"
          @delList="delListC"
          @showDrawer="onShowDrawer"
          @updata="(e)=>{item=e}"
        />
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Condition',
  props: {
    paramsObj: {
      type: Object,
      default: () => ({})
    },
    paramsIndex: {
      type: Number,
      default: 0
    },
    fenzhiIndex: {
      type: Number,
      default: 0
    },
    // 支持连字符格式的属性名
    // eslint-disable-next-line vue/prop-name-casing
    'params-obj': {
      type: Object,
      default: () => ({})
    },
    // eslint-disable-next-line vue/prop-name-casing
    'params-index': {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    // 处理连字符格式的属性，优先使用连字符格式，回退到驼峰格式
    actualParamsObj() {
      const obj = this['params-obj'] || this.paramsObj
      console.log('Condition组件接收到的数据:', obj)
      console.log('节点类型:', obj.className)
      console.log('节点名称:', obj.name)
      console.log('子节点数量:', obj.children ? obj.children.length : 0)
      if (obj.children && obj.children.length > 0) {
        console.log('子节点详情:', obj.children)
      }
      return obj
    },
    actualParamsIndex() {
      return this['params-index'] || this.paramsIndex
    }
  },
  methods: {
    addList(type, id) {
      console.log('Condition组件addList被调用:', { type, id })
      this.$emit('addList', { type, id })
      console.log('Condition组件addList事件已发出')
    },
    addListC(obj, m) {
      console.log('Condition组件addListC被调用:', obj, m)
      this.$emit('addListC', obj, m)
      this.$emit('addList', obj)
      console.log('Condition组件addListC事件已发出')
    },
    delList(t, paramsI, fenzhiI, id) {
      console.log('Condition组件删除步骤:', { type: t, actualParamsIndex: paramsI, fenzhiIndex: fenzhiI, id })
      console.log('第1步完成')

      const nodeId = id || this.actualParamsObj.id
      console.log('最终使用的nodeId:', nodeId)
      console.log('第2步完成')

      console.log('准备发出delList事件')
      console.log('第3步完成')

      this.$emit('delList', { type: t, id: nodeId })
      console.log('第4步完成')

      console.log('delList事件已发出')
      console.log('第5步完成')
    },
    delListC(obj, m) {
      console.log('delListC被调用:', obj, m)
      // 同时发出delListC和delList事件
      this.$emit('delListC', obj, m)
      this.$emit('delList', obj)
    },
    showDrawer(type, id) {
      console.log('=== Condition组件showDrawer被调用 ===')
      console.log('type:', type)
      console.log('id:', id)
      this.$emit('showDrawer', { type, id })
      console.log('showDrawer事件已发出')
    },
    onShowDrawer(data) {
      console.log('=== Condition组件onShowDrawer被调用 ===')
      console.log('接收到的数据:', data)
      this.$emit('showDrawer', data)
      console.log('showDrawer事件已发出')
    }
  }
}
</script>

<style lang="scss" scoped>
.box-header {
  color: #fff;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 4px 4px 0 0;
}
.box-header-launch {
  background-color: #576a95;
}
.box-header-cc {
  background-color: #3296fa;
}
.box-header-approval {
  background-color: #ff9431;
}
.box-body {
  padding: 16px;
  height: 52px;
}
.connectLine {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    margin: auto;
    width: 2px;
    height: 100%;
    background-color: #cacaca;
  }
}
.connectRow {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    margin: auto;
    width: 100%;
    height: 2px;
    background-color: #cacaca;
  }
}
.col-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.col-box-more:last-of-type {
  &:before {
    content: '';
    position: absolute;
    top: -3px;
    right: 0;
    height: 6px;
    width: calc(50% - 1px);
    background: #fff;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    right: 0;
    height: 6px;
    width: calc(50% - 1px);
    background: #fff;
  }
}
.col-main{
  align-items: stretch;
  box-sizing: border-box;
  background: #fff;
  justify-content: center;
  display: flex;
  position: relative;
}
.col-box-main{
  border-bottom: 2px solid #cacaca;
  border-top: 2px solid #cacaca;
}
.col-box-more:first-of-type {
  &:before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    height: 6px;
    width: calc(50% - 1px);
    background: #fff;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    height: 6px;
    width: calc(50% - 1px);
    background: #fff;
  }
}
.center-line {
  height: 100%;
  width: 2px;
  background: #cacaca;
  position: absolute;
}
.endding{
  position: relative;
  text-align: center;
  margin: auto;
  &:before{
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    margin: auto;
    border: none;
    margin-bottom: 12px;
    border-radius: 50%;
    background: #dbdcdc;
  }
}
</style>
